const VideoIcon = ({ className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      className={className}
    >
      <path
        d="M9.16663 6.79657L10.8333 6.79657"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        d="M1.66663 9.29653C1.66663 6.54667 1.66663 5.17174 2.5209 4.31747C3.37517 3.4632 4.7501 3.4632 7.49996 3.4632H8.33329C11.0832 3.4632 12.4581 3.4632 13.3124 4.31747C14.1666 5.17174 14.1666 6.54667 14.1666 9.29653V10.9632C14.1666 13.7131 14.1666 15.088 13.3124 15.9423C12.4581 16.7965 11.0832 16.7965 8.33329 16.7965H7.49996C4.7501 16.7965 3.37517 16.7965 2.5209 15.9423C1.66663 15.088 1.66663 13.7131 1.66663 10.9632V9.29653Z"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      <path
        d="M14.1666 7.55145L14.2716 7.46487C16.0347 6.01009 16.9163 5.28271 17.6248 5.63392C18.3333 5.98514 18.3333 7.14953 18.3333 9.47831V10.7815C18.3333 13.1103 18.3333 14.2747 17.6248 14.6259C16.9163 14.9771 16.0347 14.2497 14.2716 12.7949L14.1666 12.7084"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default VideoIcon;
